import { useTypedQuery } from "hooks";
import { ChecklistSettingsDashboardQueryKeys } from "modules/ChecklistSettingsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { ChecklistTemplateID } from "models";

export const useChecklistTemplateDetailsQuery = (id: ChecklistTemplateID | null) =>
  useTypedQuery({
    queryKey: ChecklistSettingsDashboardQueryKeys.templateDetails(id ?? -1),
    queryFn: async ({ endpoint, baseUrl, params }) => (await ApiInstance.post(endpoint, params, baseUrl)).data,
    refetchOnDependencies: [id],
    enabled: Boolean(id)
  });
